import { render } from "./PedidoCompraItemModal.vue?vue&type=template&id=566aee2e&ts=true"
import script from "./PedidoCompraItemModal.vue?vue&type=script&lang=ts"
export * from "./PedidoCompraItemModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__